import { Tag } from 'antd'
import CoreEnums from '../../../../../core/utils/enums'
import dayjs from 'dayjs'
import { getBpmStatusLabel } from '../../../../lib/utils'

// Utility function to convert text to title case
export const toTitleCase = (str) => {
  if (!str) return str
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
}

// Calculate duration between start and end time
export const calculateDuration = (startTime, endTime) => {
  const start = dayjs(startTime, 'HH:mm')
  const end = dayjs(endTime, 'HH:mm')
  const durationMinutes = end.diff(start, 'minute')
  const hours = Math.floor(durationMinutes / 60)
  const minutes = durationMinutes % 60
  return { hours, minutes }
}

// Generate time slots for reschedule dropdown
export const generateTimeSlots = () => {
  const timeSlots = []
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const formattedHour = hour.toString().padStart(2, '0')
      const formattedMinute = minute.toString().padStart(2, '0')
      timeSlots.push(`${formattedHour}:${formattedMinute}`)
    }
  }
  return timeSlots
}

// Generate status tag with appropriate colors (same as booking-utils)
export const generateStatusTag = (clinic, status, wasNoShow, token) => {
  let tagColor = null
  let statusText = null

  if (wasNoShow) {
    tagColor = token.colorTextDisabled
    statusText = 'No Show'
  } else {
    switch (status) {
      case CoreEnums.bookingStatuses.checkin:
        statusText = getBpmStatusLabel(clinic, status) || 'Check-in'
        tagColor = token.colorPrimaryText
        break
      case CoreEnums.bookingStatuses.screening:
        statusText = getBpmStatusLabel(clinic, status) || 'Screening'
        tagColor = token.colorSecondary
        break
      case CoreEnums.bookingStatuses.consultation:
        statusText = getBpmStatusLabel(clinic, status) || 'Consultation'
        tagColor = token.colorWarning
        break
      case CoreEnums.bookingStatuses.reception:
        statusText = getBpmStatusLabel(clinic, status) || 'Reception'
        tagColor = token.colorInfo
        break
      case CoreEnums.bookingStatuses.completed:
        statusText = getBpmStatusLabel(clinic, status) || 'Completed'
        tagColor = token.colorSuccess
        break
      case CoreEnums.bookingStatuses.cancelled:
        statusText = getBpmStatusLabel(clinic, status) || 'Cancelled'
        tagColor = token.colorError
        break
      default:
        statusText = 'Unknown'
        tagColor = token.colorTextSecondary
    }
  }

  return (
    <Tag color={tagColor} style={{ fontWeight: '500', fontSize: '13px' }}>
      {statusText}
    </Tag>
  )
}

// Get view record button text based on status and user role
export const getViewRecordText = (status, isDoctor, isNurse, isReception) => {
  if (isDoctor && status === CoreEnums.bookingStatuses.consultation) {
    return 'Begin Examination'
  }
  if (isNurse && status === CoreEnums.bookingStatuses.screening) {
    return 'Begin Examination'
  }
  if (isReception && status === CoreEnums.bookingStatuses.reception) {
    return 'Process Billing'
  }
  return 'View Record'
}
